import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * A serving arm must name the spotlight it serves. An arm with no spotlight
 * used to fall back to the legacy rescue panel, which no longer renders.
 */
const rescuePanelSplitArmSchema = z
  .object({
    weight: z.number(),
    enabled: z.boolean(),
    dropoffPercentageTrigger: z.number().min(0).max(100).optional(),
    secondsInColdTrigger: z.number().optional(),
    spotlightId: z.string().optional(),
  })
  .refine((arm) => !arm.enabled || !!arm.spotlightId, {
    message: "An enabled arm must reference a spotlight",
    path: ["spotlightId"],
  });

export const startRescuePanelSplit = {
  name: "startRescuePanelSplit" as const,
  input: z.object({
    teamId: zExt.objectId(),
    armA: rescuePanelSplitArmSchema,
    armB: rescuePanelSplitArmSchema,
    merchantDashboardVisible: z.boolean(),
  }),
  output: z.void(),
};
